exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".SlideImages1 amp-img{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/sass-loader/lib/loader.js!./src/components/contents/SlideImages1/SlideImages1.s.scss
// module id = 1126
// module chunks = 18